import React, { useState } from "react";
import PropTypes from "prop-types";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";

const FeaturesManager = ({ features, onChange, error }) => {
  const [newFeature, setNewFeature] = useState({ name: "", icon: "", icon_url: "" });
  const [localError, setLocalError] = useState(null);

  const handleAddFeature = () => {
    if (!newFeature.name.trim()) {
      setLocalError("Feature name is required.");
      return;
    }
    setLocalError(null);
    onChange([...features, { ...newFeature }]);
    setNewFeature({ name: "", icon: "", icon_url: "" });
  };

  const handleRemoveFeature = (index) => {
    const updatedFeatures = features.filter((_, i) => i !== index);
    onChange(updatedFeatures);
  };

  const handleFeatureChange = (index, field, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index] = { ...updatedFeatures[index], [field]: value };
    onChange(updatedFeatures);
  };

  const handleFeatureFileChange = (index, event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    const updatedFeatures = [...features];
    updatedFeatures[index] = {
      ...updatedFeatures[index],
      icon: file,
      icon_url: URL.createObjectURL(file)
    };
    onChange(updatedFeatures);
  };

  const handleNewFeatureFileChange = (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    setNewFeature({
      ...newFeature,
      icon: file,
      icon_url: URL.createObjectURL(file)
    });
    if (localError) setLocalError(null);
  };

  return (
    <div className="col-12">
      <div className="alert text-center alert-success my-5">
        Features
      </div>
      {error && <div className="alert alert-danger py-2">{error}</div>}

      {/* Existing Features */}
      {features && features.length > 0 && (
        <div className="row g-3 mb-4">
          {features.map((feature, index) => (
            <div key={index} className="col-12">
              <div className="card border-0 shadow-sm hover-shadow transition-all">
                <div className="card-body p-3">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div className="feature-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', fontSize: '14px' }}>
                        {index + 1}
                      </div>
                    </div>
                    <div className="col">
                      <div className="row align-items-center">

                        <FormInputFile
                          field={{
                            name: `feature_${index}_icon`,
                            label: "Icon",
                            type: "file",
                            fieldSize: "col-md-5 mb-2 mb-md-0",
                            accept: "image/png, image/jpeg, image/jpg, image/svg+xml",
                          }}
                          handleChange={(event) => handleFeatureFileChange(index, event)}
                          error={null}
                          imagePreview={feature.icon_url || null}
                        />

                        <FormInput
                          field={{
                            name: `feature_${index}_name`,
                            label: "Feature Name",
                            type: "text",
                            fieldSize: "col-md-5 mb-2 mb-md-0",
                            placeholder: "Enter feature name",
                          }}
                          value={feature.name}
                          handleChange={(e) => handleFeatureChange(index, "name", e.target.value)}
                          error={null}
                        />

                        <div className="col-md-2 mt-4">
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-md w-100"
                            onClick={() => handleRemoveFeature(index)}
                          >
                            Remove
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Add New Feature */}
      <div className="card border-primary border-2 shadow-sm">
        <div className="card-body p-4">
          <div className="row align-items-center">
            <div className="col-auto">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', fontSize: '14px' }}>
                <i className="fas fa-plus"></i>
              </div>
            </div>
            <div className="col">
              <div className="row align-items-center">

                <FormInputFile
                  field={{
                    name: "new_feature_icon",
                    label: "Icon",
                    type: "file",
                    fieldSize: "col-md-5 mb-2 mb-md-0",
                    accept: "image/png, image/jpeg, image/jpg, image/svg+xml",
                  }}
                  handleChange={handleNewFeatureFileChange}
                  error={null}
                  imagePreview={newFeature.icon_url || null}
                />

                <FormInput
                  field={{
                    name: "new_feature_name",
                    label: "Feature Name",
                    type: "text",
                    fieldSize: "col-md-5 mb-2 mb-md-0",
                    placeholder: "Enter feature name",
                  }}
                  value={newFeature.name}
                  handleChange={(e) => {
                    setNewFeature({ ...newFeature, name: e.target.value });
                    if (localError) setLocalError(null);
                  }}
                  error={localError}
                />

                <div className="col-md-2 mt-4">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleAddFeature}
                  >
                    Add
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FeaturesManager.propTypes = {
  features: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

FeaturesManager.defaultProps = {
  features: [],
  error: null,
};

export default FeaturesManager;
